import { api } from "@/api/client";

/**
 * Загруженность склада: активное время по людям.
 *
 * Считается сессионизацией журнала действий, а не разницей «создан → завершён»:
 * смены общие (открыл один, доканчивал другой), а календарная разница включает
 * обед и ожидание погрузчика.
 */

export interface UserWorkload {
  user_id: number | null;
  username: string;
  events: number;
  active_seconds: number;
  /** Отрезков работы: пауза длиннее порога разрывает отрезок. */
  segments: number;
  first_at: string | null;
  last_at: string | null;
  by_page: Record<string, number>;
  by_day: Record<string, number>;
}

export interface WorkloadResponse {
  date_from: string;
  date_to: string;
  idle_minutes: number;
  page_titles: Record<string, string>;
  users: UserWorkload[];
}

export async function getWorkload(params: {
  date_from?: string;
  date_to?: string;
  page?: string;
}): Promise<WorkloadResponse> {
  const { data } = await api.get<WorkloadResponse>("/activity/workload", { params });
  return data;
}

/** «2 ч 15 мин» / «15 мин» / «—». Секунды на экране никому не нужны. */
export function fmtDuration(seconds: number): string {
  if (!seconds) return "—";
  const h = Math.floor(seconds / 3600);
  const m = Math.round((seconds % 3600) / 60);
  if (!h) return `${m} мин`;
  return m ? `${h} ч ${m} мин` : `${h} ч`;
}
